// common
import '@ungap/custom-elements' // fix safari
import './fix-scrollbar-width'
// import './scrolled'
// import './photos'
import './menu'

// webcomponents
import './webcomponent/menu'
import './webcomponent/scroll-animate'
import './webcomponent/slider'
import './webcomponent/field'

// blocks
import './block/media-text-full'
import './block/list-children'
import './block/front-page-numbers'
import './block/accordion'
import './block/form-job'
import './block/form-contact'
import './block/form-formation'
import './block/form-login'
import './block/form-logout'
import './block/form-register-subscriber'
import './block/form-register-shareholder'

// eslint-disable-next-line no-console
console.log('Ok ! ')
